import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import hapi from "@/lib/health";

const HealthAuthContext = createContext(null);
export const useHealth = () => useContext(HealthAuthContext);

export function HealthAuthProvider({ children }) {
  const [state, setState] = useState(null); // null=checking, {account,group,can_switch,is_holder}=authed, false=anon

  const loadMe = useCallback(async () => {
    try { const { data } = await hapi.get("/account/me"); setState(data); return data; }
    catch { setState(false); return false; }
  }, []);
  useEffect(() => { loadMe(); }, [loadMe]);

  const signup = async (body) => { await hapi.post("/account/signup", body); return loadMe(); };
  const login = async (email, password) => { await hapi.post("/account/login", { email, password }); return loadMe(); };
  const logout = async () => { try { await hapi.post("/account/logout"); } catch { /* ignore */ } setState(false); };
  const switchProfile = async (id) => { await hapi.post("/account/switch", { target_id: id }); return loadMe(); };

  return (
    <HealthAuthContext.Provider value={{ state, loadMe, signup, login, logout, switchProfile }}>
      {children}
    </HealthAuthContext.Provider>
  );
}
